import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRedirectWhenEmptyMenu = ({
	routesCount,
	sideBarItemsCount,
	isLoading,
	to = '/',
}: {
	routesCount: number;
	sideBarItemsCount: number;
	isLoading: boolean;
	to?: string;
}) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (routesCount !== 0 && sideBarItemsCount === 0 && !isLoading) {
			navigate(to);
		}
	}, [routesCount, sideBarItemsCount, isLoading, navigate, to]);
};
